import axios from './instance';

// Fetch all projects
export const getProjects = async () => {
  try {
    const res = await axios.get('http://localhost:8000/api/projects');
    return res.data;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};

// Fetch a single project by ID
export const getProjectById = async (projectId) => {
  try {
    const res = await axios.get(`http://localhost:8000/api/projects/${projectId}`);
    return res.data;
  } catch (error) {
    console.error(`Error fetching project with ID ${projectId}:`, error);
    throw error;
  }
};

// Create a new project
export const createProject = async (projectData) => {
  try {
    const res = await axios.post('http://localhost:8000/api/projects', projectData);
    return res.data;
  } catch (error) {
    console.error("Error creating project:", error);
    throw error;
  }
};

// Update an existing project
export const updateProject = async (projectId, projectData) => {
  try {
    const res = await axios.patch(`http://localhost:8000/api/projects/${projectId}`, projectData);
    return res.data;
  } catch (error) {
    console.error(`Error updating project with ID ${projectId}:`, error);
    throw error;
  }
};

// Delete a project by ID
export const deleteProject = async (projectId) => {
  try {
    const res = await axios.delete(`http://localhost:8000/api/projects/${projectId}`);
    return res.data;
  } catch (error) {
    console.error(`Error deleting project with ID ${projectId}:`, error);
    throw error;
  }
};

// Add a member to a project
export const addMemberToProject = async (projectId, memberData) => {
  try {
    const res = await axios.post(`http://localhost:8000/api/projects/${projectId}/members`, memberData);
    return res.data;
  } catch (error) {
    console.error(`Error adding member to project with ID ${projectId}:`, error);
    throw error;
  }
};

// Remove a member from a project
export const removeMemberFromProject = async (projectId, memberId) => {
  try {
    const res = await axios.delete(`http://localhost:8000/api/projects/${projectId}/members/${memberId}`);
    return res.data;
  } catch (error) {
    console.error(`Error removing member from project with ID ${projectId}:`, error);
    throw error;
  }
};








